import ProjectCreateButton from './ProjectCreateButton/ProjectCreateButton'
import ProjectFilterInput from './ProjectFilterInput/ProjectFilterInput'
import ProjectFilterVintages from './ProjectFilterVintages/ProjectFilterVintages'

export const options = {
  ProjectFilterInput,
  ProjectCreateButton,
  ProjectFilterVintages
}
